<template>
  <ak-cards-item
    v-for="(item, index) in list"
    :key="index"
    class="app-card-wrapper c-faux-text-wrapper"
  >
    <ak-card class="app-card app-card--loading">
      <div class="h-225 app-card__preview"></div>
      <ak-card-body class="block">
        <div class="pull-right text-right pl-small">
          <div class="c-faux-text c-faux-text--bigger width-50"></div>
          <br />
          <div class="c-faux-text width-75"></div>
        </div>

        <div class="c-faux-text c-faux-text--bigger width-125"></div>
        <br />
        <div class="c-faux-text width-75"></div>
      </ak-card-body>

      <ak-card-footer>
        <div class="c-faux-text width-50"></div>
      </ak-card-footer>
    </ak-card>
  </ak-cards-item>
</template>

<script>
import CardsItem from '@akerolabs/akero-vue/src/components/cards/CardsItem.vue'
import Card from '@akerolabs/akero-vue/src/components/cards/Card.vue'
import CardBody from '@akerolabs/akero-vue/src/components/cards/CardBody.vue'
import CardImage from '@akerolabs/akero-vue/src/components/cards/CardImage.vue'
import CardFooter from '@akerolabs/akero-vue/src/components/cards/CardFooter.vue'

import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'AkAppsListCardsLoading',

  components: {
    [CardsItem.name]: CardsItem,
    [Card.name]: Card,
    [CardBody.name]: CardBody,
    [CardImage.name]: CardImage,
    [CardFooter.name]: CardFooter,
  },

  setup() {
    const list = ref(Array(10))

    return {
      list,
    }
  },
})
</script>

<style lang="scss">
@import '@akerolabs/akero-vue/src/scss/_settings.scss';
.app-card--loading {
  background-color: #fff;
  .app-card__preview {
    background: $color-grey-light !important;
  }
}
</style>
